/**
 * @ngdoc component
 * @name common.shopcart.component:ItxShopCartButtonCmp
 * @requires common.shopCart.service:ItxShopCartFct
 * @requires ItxHeaderFct
 * @description
 * Shopcart icon button placed in the header.
 * # Main functionalities:
 * - Show quantity of items added to the shopcart
 * - Open shopcart side menu
*/
(function () {

    'use strict';

    var ItxShopCartButtonCmp = {
        controller: ItxShopCartButtonCmpCtrl,
        templateUrl: 'shop-cart-button.component.html',
        bindings: {
            onClickCart: '&'
        }
    };

    angular.module('itxApp.common')
        .component('itxShopCartButton', ItxShopCartButtonCmp);

    ItxShopCartButtonCmpCtrl.$inject = [
        'ItxShopCartFct',
        '$rootScope'
    ];

    function ItxShopCartButtonCmpCtrl( 
        ItxShopCartFct,
        $rootScope
    ) {
        var _this = this;
        _this.shopCartItems = 0;

        _this.$onInit = function () {
              _this.shopCart = ItxShopCartFct.getState();
              _setItemsCmp();
        };

        $rootScope.$on('itx-shop-cart:updated', function(event , shopCart) {
            _this.shopCart = shopCart;
            _setItemsCmp();
        });

        function _setItemsCmp() {
            _this.shopCartItems = _this.shopCart.state.totalItems;
        }
    }
    
})();